export const getDisplayName = (entity) => entity?.name ?? '-';

export default getDisplayName;
